import { Divider, Grid, Stack } from "@mui/material";
import { SSText } from "src/components/base/components/SSText";
import { useEventCardCtx } from "./EventCard";
import { pluralize } from "src/utils/utils";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";
import React from "react";
import { filterItemizeSeatCounts } from "./utils.seatCount";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";

// prettier-ignore
const SeatCountListItem = (props: { seatCount: number; label: string; id: string }) => {
  const eventCardCtx = useEventCardCtx();
  const { HOME_PAGE_SETTINGS } = useTeamConfig();

  return (
    <>
      <Stack direction={"row"} justifyContent={"space-between"} py={1}>
        <SSText
          variant="body"
          fontWeight={600}
          fontSize={"0.95rem"}
          color={eventCardCtx.colors.textColor}
        >
          {props.seatCount} {pluralize("Seat", props.seatCount)}
        </SSText>
        {!HOME_PAGE_SETTINGS?.EVENT_CARD?.HIDE_SEAT_COUNT_MAPPING?.[props.id] ? (
          <SSText
            variant="body"
            fontSize={"0.9rem"}
            color={eventCardCtx.colors.textColor}
            sx={{ opacity: 0.7 }}
          >
            {props.label}
          </SSText>
        ) : null}
      </Stack>
      <Divider
        sx={{
          backgroundColor: eventCardCtx.colors.borderColor,
          borderColor: "transparent",
        }}
      />
    </>
  );
};

export function EventCardSeatInformation() {
  const { md: mdUp } = useCssMediaQuery("up");
  const eventCardCtx = useEventCardCtx();
  const teamConfig = useTeamConfig();
  const event = eventCardCtx?.event;

  const seatCounts = filterItemizeSeatCounts({ event, teamConfig });

  return (
    <Grid
      container
      px={mdUp ? 3 : 2}
      py={2}
      pt={0}
      sx={{
        "& > :last-child": {
          "& .MuiDivider-root": {
            display: "none",
          },
        },
      }}
    >
      {seatCounts.map((seatCountItem) => {
        if (seatCountItem.seatCount > 0) {
          return (
            <Grid item xs={12} key={seatCountItem.id}>
              <SeatCountListItem
                seatCount={seatCountItem.seatCount}
                label={seatCountItem.label}
                id={seatCountItem.id}
              />
            </Grid>
          );
        }
        return null;
      })}
    </Grid>
  );
}
